import { Button } from "@backslashbuild/pp-ui";
import React from "react";

export default function ViewHmrcErrorsButton({ onClick }) {
  return (
    <Button
      large
      onClick={() => {
        onClick();
      }}
    >
      View HMRC Errors
    </Button>
  );
}
